import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/admissions/admission-applications";

export const Route = createFileRoute(
  "/admin/_admissions/admission-applications"
)({
  component: Page,
});
